import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { FreightTicker } from '../components/FreightTicker';
import { StatsSection } from '../components/StatsSection';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Differentiators } from '../components/Differentiators';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { WhoWeServeSection } from '../components/WhoWeServeSection';
import { CarrierQuiz } from '../components/CarrierQuiz';
import { Testimonials } from '../components/Testimonials';
import { BrokerNetwork, ServiceAreas } from '../components/BrokerNetwork';
import { CalloutBanner } from '../components/CalloutBanner';
import { CTASection } from '../components/CTAButtons';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';

const Home = () => {
  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
    }
  }, []);

  return (
    <div className="min-h-screen" id="main-content">
      <SEO
        title="Truck Dispatch Services | Flow Fleet Solutions"
        description="Professional truck dispatch services helping owner operators and fleets maximize revenue through premium loads, broker negotiation, and dedicated dispatch support."
        keywords={[
          'truck dispatch services', 'freight dispatch company', 'owner operator dispatch',
          'dispatch service near me', 'carrier dispatch company', 'freight management',
        ]}
        canonicalPath="/"
        breadcrumbs={[{ name: 'Home', path: '/' }]}
      />
      <Header />
      <HeroSection />
      <FreightTicker />
      <StatsSection />
      <ServicesSection />
      <WhyChooseUs />
      <Differentiators />
      <HowItWorksSection />
      <WhoWeServeSection />
      <CarrierQuiz />
      <Testimonials />
      <BrokerNetwork />
      <ServiceAreas />
      <CalloutBanner />
      <CTASection />
      <Footer />
    </div>
  );
};

export default Home;
